import React from 'react';
import SVGIcon from '../components/SVGIcon';
import type { DocumentType } from '../graphql/generated';
import { gql } from '../graphql/generated';
import { PostType } from '../graphql/generated/graphql';
import { getStateIcon } from '../post/PostIcon';
import useIsLayoutSize from '../post/utils/useIsLayoutSize';
import { LayoutSize } from '../post/utils/useLayoutSize';
import Link from '../utils/router/Link';
import { publicPostPath } from '../utils/url/postPath';
import * as styles from './PublicTopicPosts.module.scss';

const POST_FRAGMENT = gql(`
  fragment PublicTopicPosts_posts on PublicPost {
    id
    ...publicPostPath_post
  }
`);

const PostLink = ({ post }: { post: DocumentType<typeof POST_FRAGMENT> }) => (
  <Link className={styles.postLink} to={publicPostPath(post)}>
    <div className={styles.iconContainer}>
      <SVGIcon>
        {getStateIcon(
          {
            draft: false,
            archived: false,
            type: PostType.Post,
            public: false,
          },
          true,
        )}
      </SVGIcon>
    </div>
    {post.title}
  </Link>
);

interface PublicTopicPostsProps {
  posts: DocumentType<typeof POST_FRAGMENT>[];
}

const PublicTopicPosts = ({ posts }: PublicTopicPostsProps) => {
  const isMobile = useIsLayoutSize(LayoutSize.mobile);

  if (isMobile) {
    return (
      <div className={styles.container}>
        <div className={styles.column}>
          {posts.map((post) => (
            <PostLink key={post.id} post={post} />
          ))}
        </div>
      </div>
    );
  }

  const left = posts.filter((_, i) => i % 2 === 0);
  const right = posts.filter((_, i) => i % 2 === 1);

  return (
    <div className={styles.container}>
      <div className={styles.column}>
        {left.map((post) => (
          <PostLink key={post.id} post={post} />
        ))}
      </div>
      <div className={styles.column}>
        {right.map((post) => (
          <PostLink key={post.id} post={post} />
        ))}
      </div>
    </div>
  );
};

export default PublicTopicPosts;
